import * as React from 'react'
import { asDecimal, formatPrice, sumDecimalArray } from '@helpers/utils'
import Table from '@components/table/table'
import { PaymentRegister } from '@models/payments'
import Decimal from 'decimal.js'

interface Props {
  paymentRegisters: PaymentRegister[]
}

export const PaymentRegisterUserCashboxTransactionsTableFooter: React.FC<Props> = ({ paymentRegisters }) => {
  const paymentIn = paymentRegisters.filter(row => row.type === 'KP' && row.status === 'success')
  const paymentOut = paymentRegisters.filter(row => row.type === 'KW' && row.status === 'success')

  const totalPaymentIn = React.useMemo(() => sumDecimalArray(paymentIn.map(row => asDecimal(row.amount))), [paymentIn])
  const totalPaymentOut = React.useMemo(
    () => sumDecimalArray(paymentOut.map(row => Decimal.abs(asDecimal(row.amount)))),
    [paymentOut],
  )

  return (
    <Table.Row>
      <Table.Cell colSpan={3} className="text-right align-middle reservation-list__summary-cell">
        <strong className="mr-2">Razem KP / KW:</strong>
      </Table.Cell>
      <Table.Cell className="reservation-list__summary-cell">
        <ValueBLock title="Wpłaty w recepcji (KP)" price={formatPrice(totalPaymentIn.toString())} />
      </Table.Cell>

      <Table.Cell colSpan={2} className="reservation-list__summary-cell">
        <ValueBLock title="Wypłaty w recepcji (KW)" price={formatPrice(totalPaymentOut.toString())} />
      </Table.Cell>
    </Table.Row>
  )
}

const ValueBLock = ({ title, price }) => (
  <div className="px-4 py-2 text-white reservation-list__summary-block">
    <span className="d-block mb-1 font-11 mt-1">{title}</span>
    <strong>{price}</strong>
  </div>
)
